module.exports = __webpack_public_path__ + "img/281813_604233_4B3426_442B22-256px.a0d5e75f.png";